export enum  WarrantyExtensionType {
    saleWarrantyExtension = 1,
    repairWarrantyExtension = 2
}

export enum  WarrantyExtensionTypeDescription {
    saleWarrantyExtension = 'Sale Warranty Extension',
    repairWarrantyExtension = 'Repair Warranty Extension'
}